@if(user()?.agentInfo || hasCoachTransport()) {
<div class="tw-flex tw-items-center">
  @if(showLauncher) {
  <button #softphoneOpener mat-button type="button" class="tw-gap-2"
    [class.btn-success]="statusTone() === 'success'"
    [class.btn-warning]="statusTone() === 'warning'"
    [class.btn-danger]="statusTone() === 'danger'"
    [class.btn-secondary]="statusTone() === 'secondary'"
    (click)="openPanel($event)">
    <mat-icon>phone</mat-icon>
    <span>{{statusText()}}</span>
  </button>
  }
</div>
}

<ng-template #softphoneOverlayContent>
  @let call = callState();
  <div cdkDrag
    class="softphone-panel tw-z-[1000] tw-w-full tw-max-h-[calc(100vh_-_1.5rem)] tw-overflow-hidden tw-rounded-lg tw-shadow-[0_12px_36px_rgba(15,23,42,0.18),0_2px_8px_rgba(15,23,42,0.12)] surface-main-darker"
    (cdkDragEnded)="onPanelDragEnded($event)">
    <div class="tw-flex tw-items-center tw-justify-between tw-gap-2 tw-px-3 tw-py-2 tw-border-b">
      <div cdkDragHandle class="tw-flex tw-items-center tw-gap-3 tw-min-w-0 tw-flex-1 tw-cursor-move tw-select-none">
        <mat-icon class="tw-shrink-0">drag_indicator</mat-icon>
        <div class="tw-min-w-0 tw-flex-1 tw-flex tw-items-center tw-gap-2">
          @if(panelState().collapsed || !showFooterConnectionSummary()) {
          <span class="uw-tag tw-shrink-0" [class.uw-tag-success]="statusTone() === 'success'"
            [class.uw-tag-warning]="statusTone() === 'warning'" [class.uw-tag-danger]="statusTone() === 'danger'"
            [class.uw-tag-secondary]="statusTone() === 'secondary'">
            {{statusText()}}
          </span>
          }
          @if(panelModeText() || (showFooterConnectionSummary() ? 'Softphone' : undefined); as modeText) {
          <span class="tg-sm text-muted tw-truncate">{{modeText}}</span>
          }
        </div>
        @if(call.active) {
        <span class="tg-sm tw-font-mono tw-shrink-0">{{mainCallTimerText()}}</span>
        } @else {
        <span class="tg-sm text-muted tw-whitespace-nowrap tw-shrink-0">Last seen: {{lastSeenText()}}</span>
        }
      </div>
      <button mat-icon-button type="button" (click)="togglePanelCollapsed()"
        [attr.aria-label]="panelState().collapsed ? 'Expand softphone' : 'Collapse softphone'"
        [matTooltip]="panelState().collapsed ? 'Expand' : 'Collapse'">
        <mat-icon>{{ panelState().collapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
      </button>
      <button mat-icon-button type="button" (click)="closePanel()" [disabled]="hasAnyCall()"
        aria-label="Close softphone" matTooltip="Close">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    @if(!panelState().collapsed) {
    <div class="softphone-body tw-overflow-y-auto tw-p-3">
      @let loading = loadingState();
      @let dialer = dialerState();
      <div class="tw-flex tw-flex-col tw-items-stretch tw-gap-2 tw-pb-2">
        @if(contractVersionMismatch()) {
        <div class="uw-message uw-message-warning tg-sm">
          A newer soft-phone version is available. Refresh this page before continuing.
        </div>
        }
        @if(browserSessionMode() === 'standby' || browserSessionMode() === 'blocked') {
        <div class="uw-message uw-message-warning tw-space-y-2">
          <div class="tg-sm tw-font-semibold">
            {{ browserSessionMode() === 'blocked' && !activeBrowserSession()
              ? 'Soft phone is still busy'
              : activeBrowserSession()
                ? 'Soft phone is active in another browser'
                : 'Soft phone is in standby' }}
          </div>
          @if(activeBrowserSession(); as activeBrowser) {
          <div class="tg-sm">
            {{activeBrowser.browserName}} on {{activeBrowser.osName}} · Last seen {{browserSessionLastSeenText()}}
          </div>
          }
          @if(browserSessionMode() === 'blocked') {
          <div class="tg-sm">Switching is blocked until the active softphone call ends.</div>
          }
          <div class="uw-message-actions">
            <button mat-flat-button type="button" (click)="switchToThisBrowser()" [disabled]="switchingBrowserSession()">
              Switch to this browser
            </button>
          </div>
        </div>
        } @else if(browserSessionMode() === 'unverified' && !ownerRecovery()) {
        <div class="uw-message uw-message-danger tw-space-y-2">
          <div class="tg-sm">Soft phone ownership could not be verified. No calls will start in this browser.</div>
          <div class="uw-message-actions">
            <button mat-flat-button type="button" (click)="retryBrowserSession()">Retry</button>
          </div>
        </div>
        }
        @if(ownerRecovery(); as recovery) {
        <div class="uw-message uw-message-warning tw-space-y-2">
          <div class="tg-sm tw-font-semibold">
            {{ recovery.status === 'blocked'
              ? 'Another VOXR tab is blocking the soft phone'
              : 'Trying to recover the soft phone' }}
          </div>
          <div class="tg-sm">
            {{ recovery.status === 'blocked'
              ? recovery.detail || 'Automatic recovery could not release the browser lock. Find the VOXR tab that owns the soft phone and release it there, or refresh or close that tab.'
              : 'VOXR is asking the previous owner tab to release the soft phone safely.' }}
          </div>
          @if(recovery.status === 'blocked') {
          <div class="uw-message-actions">
            <button mat-flat-button type="button" (click)="retryOwnerRecovery()">Try recovery again</button>
            <button mat-button type="button" (click)="findOwnerTab()">Find owner tab</button>
          </div>
          }
        </div>
        }
        @if(enabled()) {
        @if(loading.message) {
        <div class="uw-message uw-message-info tg-sm">
          {{loading.message}}
        </div>
        }

        @if(!wakeLockSupported) {
        <div class="uw-message uw-message-warning tw-flex tw-items-center tw-gap-2">
          <mat-icon class="tw-shrink-0">warning_amber</mat-icon>
          <span class="tg-sm">Background tabs may miss calls.</span>
        </div>
        }

        @if(setupIssue()) {
        <div class="uw-message uw-message-warning tw-space-y-2" role="status">
          <div class="tg-sm tw-font-semibold">{{setupIssueTitle()}}</div>
          <div class="tg-sm">{{setupIssueMessage()}}</div>
          <div class="uw-message-actions">
            <button mat-flat-button type="button" (click)="checkSetup()" [disabled]="checkingSetup()"
              [attr.aria-busy]="checkingSetup()">{{checkingSetup() ? 'Checking…' : 'Check again'}}</button>
          </div>
        </div>
        }

        @if(showSingleConnectionErrorCard()) {
        <div class="uw-card tw-flex tw-items-center tw-justify-between tw-gap-3">
          <div class="tg-sm text-muted">{{ primaryStatusMessage() }}</div>
          <div class="tw-flex tw-items-center tw-gap-2">
            <button mat-stroked-button type="button" (click)="reconnect()">Reconnect</button>
            <button mat-button type="button" (click)="openConnectionDetailsDialog()">Details</button>
          </div>
        </div>
        }

        @if(hasIncomingTransfer()) {
        <div class="uw-card uw-progress-bar-parent tw-space-y-2">
          <div class="tw-flex tw-items-start tw-justify-between tw-gap-3">
            <div class="tw-min-w-0">
              <div class="tg-title">{{ !transferContext() ? 'Incoming call' : transferContext()?.transfer?.data?.['directOutbound'] === true ? 'Unqualified direct call' : transferContext()?.incomingType === 'recovery' ? 'Recovery call' : 'Incoming transfer' }}</div>
              @if(transferInfo()) {
              @if(transferInfo()?.handoff?.ownershipReason === 'screened-human-transfer') {
              <div class="uw-message uw-message-info tg-sm">AI handled screening. The caller is ready for an agent.</div>
              }
              @if(transferInfo()?.handoff?.screenerAction; as action) {
              <div class="tg-sm text-muted">Screener action: {{ action === 'message' ? 'Use a response' : action === 'agent' ? 'Transfer to agent' : 'AI conversation' }}</div>
              }
              <app-transfer-info [info]="transferInfo()" [compact]="true" emptyLabel="Lead" />
              } @else {
              <div class="tg-sm text-muted">{{ transferContext() ? 'Answer in VOXR softphone' : 'Answer here' }}</div>
              }
            </div>
            @if(transferContext()) {
            <span class="uw-tag uw-tag-info tw-shrink-0">Needs action</span>
            }
          </div>
          <div class="tw-grid tw-grid-cols-2 tw-gap-2">
            <button mat-flat-button class="btn-success" type="button" [disabled]="!canHandleIncomingTransfer()" (click)="acceptIncoming()">
              <mat-icon>call</mat-icon>
              Accept
            </button>
            <button mat-flat-button class="btn-danger" type="button" [disabled]="!canHandleIncomingTransfer()" (click)="rejectIncoming()">
              <mat-icon>call_end</mat-icon>
              Reject
            </button>
          </div>
        </div>
        }

        @if(incomingTransferNotice()) {
        <div class="uw-card tw-space-y-2">
          <div class="tw-flex tw-items-start tw-gap-3">
            <mat-icon class="text-warning tw-shrink-0">phone_in_talk</mat-icon>
            <div class="tw-min-w-0">
              <div class="tg-title">{{ incomingTransferNotice()?.incomingType === 'recovery' ? 'Recovery call in another VOXR tab' : 'Incoming transfer in another VOXR tab' }}</div>
              <div class="tg-sm text-muted">Open the matching workspace tab to accept or reject it.</div>
            </div>
          </div>
          <button mat-flat-button class="btn-warning tw-w-full" type="button" (click)="goToIncomingTransferTab()">
            <mat-icon>open_in_new</mat-icon>
            {{ incomingTransferNotice()?.incomingType === 'recovery' ? 'Go to recovery call tab' : 'Go to transfer tab' }}
          </button>
          <div class="tg-sm text-muted">If your browser does not switch tabs, select the matching workspace tab manually.</div>
        </div>
        }

        @if(call.remoteActive) {
        <div class="uw-card tw-space-y-2">
          <div class="tw-flex tw-items-start tw-gap-3">
            <mat-icon class="text-success tw-shrink-0">phone_in_talk</mat-icon>
            <div class="tw-min-w-0">
              <div class="tg-title">Call active in another VOXR tab</div>
              <div class="tg-sm text-muted">Go to the tab that owns the softphone to manage this call.</div>
            </div>
          </div>
          <button mat-flat-button class="btn-success tw-w-full" type="button" (click)="goToActiveCallTab()">
            <mat-icon>open_in_new</mat-icon>
            Go to active call tab
          </button>
          <div class="tg-sm text-muted">If your browser does not switch tabs, select the other VOXR tab manually.</div>
        </div>
        }

        @if(call.active) {
        <div class="uw-card tw-space-y-2">
          @if(shouldShowTransferInfoOnActiveCall()) {
          @if(transferInfo()?.handoff?.ownershipReason === 'screened-human-transfer') {
              <div class="uw-message uw-message-info tg-sm">AI handled screening. The caller is ready for an agent.</div>
              }
              @if(transferInfo()?.handoff?.screenerAction; as action) {
              <div class="tg-sm text-muted">Screener action: {{ action === 'message' ? 'Use a response' : action === 'agent' ? 'Transfer to agent' : 'AI conversation' }}</div>
              }
              <app-transfer-info [info]="transferInfo()" [compact]="true" emptyLabel="Lead" />
          } @else {
          <div class="tw-flex tw-items-center tw-gap-3">
            <div
              class="surface-info tw-inline-flex tw-h-8 tw-w-8 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-font-semibold tw-uppercase">
              <mat-icon>person</mat-icon>
            </div>
            <div class="tw-min-w-0 tw-flex-1">
              <div class="tg-title tw-truncate">{{ activeCallDisplayName() }}</div>
              @if(activeCallDisplayDetail() !== activeCallStatusLabel() && activeCallDisplayDetail() !== activeCallDisplayName()) {
              <div class="tg-sm text-muted tw-truncate">{{ activeCallDisplayDetail() }}</div>
              }
            </div>
          </div>
          }
          <div class="softphone-call-footer tw-flex tw-flex-wrap tw-items-center tw-justify-between tw-gap-2 tg-sm text-muted">
            @if(transferContext()?.incomingType === 'recovery') {
            <span>Recovery call</span>
            } @else if(hasConferenceParticipants()) {
            <span>Conference active</span>
            } @else if(shouldShowTransferInfoOnActiveCall()) {
            <span>Transfer connected</span>
            } @else {
            <span>Outgoing call</span>
            }
            <span class="tw-inline-flex tw-items-center tw-gap-2">
              @if(callQuality(); as quality) {
              <span class="uw-tag tw-shrink-0 tw-inline-flex tw-items-center tw-gap-1" tabindex="0" role="img"
                [class.uw-tag-success]="quality.level === 'good'"
                [class.uw-tag-warning]="quality.level === 'fair' || quality.level === 'reconnecting'"
                [class.uw-tag-danger]="quality.level === 'poor'"
                [matTooltip]="callQualityDetail()"
                [attr.aria-label]="'Connection quality: ' + callQualityLabel() + '. ' + callQualityDetail()">
                <mat-icon class="tg-sm">{{ quality.level === 'poor' ? 'signal_cellular_connected_no_internet_4_bar' : 'signal_cellular_alt' }}</mat-icon>
                {{ callQualityLabel() }}
              </span>
              }
              <span class="uw-tag uw-tag-info tw-shrink-0">{{activeCallStatusLabel()}}</span>
            </span>
          </div>
          @if(callQuality()?.level === 'poor' || callQuality()?.level === 'reconnecting') {
          <div class="uw-message uw-message-warning tg-sm">Your network connection is unstable. The other party may hear you cut out.</div>
          }
          @if(call.callerIdMessage) {
          <div class="tg-sm text-warning">{{ call.callerIdMessage }}</div>
          }
        </div>
        }

        @if(!hasAnyCall()) {
        @if(callLeadContext(); as callContext) {
        <div class="uw-card tw-w-full tw-space-y-1">
          <div class="tg-sm tw-font-semibold">Call the lead</div>
          <div class="tg-sm text-muted tw-truncate">
            {{ callContext.leadName || 'Lead' }} - {{ formatPhoneForDisplay(callContext.leadPhone) }}
            @if(callContext.source === 'call-logs') { <span>(from call logs)</span> }
            @if(callContext.source === 'campaign-tasks') { <span>(from tasks)</span> }
          </div>
        </div>
        }

        @if(outboundBlockedOutsideWorkspace()) {
        <div class="uw-message uw-message-info tg-sm">
          Open a workspace to place an outbound softphone call. Inbound transfers and connection status remain available
          here.
        </div>
        }

        @if(isWorkspaceRoute() && canManualCall()) {
        <div class="uw-card tw-space-y-2">
          <button type="button"
            class="tw-flex tw-w-full tw-items-start tw-justify-between tw-gap-3 tw-border-0 tw-bg-transparent tw-p-0 tw-text-left"
            (click)="toggleOutboundSettingsCollapsed()"
            [attr.aria-expanded]="!panelState().outboundSettingsCollapsed"
            [attr.aria-label]="panelState().outboundSettingsCollapsed ? 'Expand outbound settings' : 'Collapse outbound settings'">
            <span class="tw-flex tw-min-w-0 tw-flex-1 tw-flex-col">
              <span class="tg-title">Outbound settings</span>
              @if(panelState().outboundSettingsCollapsed) {
              @let outboundSummary = collapsedOutboundSettingsSummary();
              <span class="tg-sm text-muted tw-flex tw-flex-col tw-min-w-0">
                <span class="tw-truncate">{{ outboundSummary.integration }}</span>
                <span class="tw-truncate">{{ outboundSummary.callerId }}</span>
              </span>
              } @else {
              <span class="tg-sm text-muted">Choose the integration and caller ID used for manual softphone calls.</span>
              }
            </span>
            <mat-icon class="text-muted tw-shrink-0">{{ panelState().outboundSettingsCollapsed ? 'expand_more' : 'expand_less' }}</mat-icon>
          </button>

          @if(!panelState().outboundSettingsCollapsed) {
            <div class="tw-space-y-2">
            @if(integrationOptions().length > 1) {
              <mat-form-field class="tw-w-full" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Integration</mat-label>
                <mat-select
                  [ngModel]="selectedIntegrationId()"
                  (ngModelChange)="onSelectedIntegrationChange($event)"
                  [matTooltip]="selectedIntegrationOption()?.tooltip">
                  @for (option of integrationOptions(); track option.integrationId) {
                  <mat-option [value]="option.integrationId" [matTooltip]="option.tooltip" matTooltipPosition="left">
                    {{ option.title }}
                  </mat-option>
                  }
                </mat-select>
              </mat-form-field>
              } @else {
            @let onlyIntegration = integrationOptions()[0];
            @if(onlyIntegration) {
            <div class="tg-sm text-muted" [matTooltip]="onlyIntegration.tooltip">Integration: {{ onlyIntegration.title }}</div>
              }
              }

            <mat-form-field class="tw-w-full" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Caller ID mode</mat-label>
              <mat-select [ngModel]="dialer.originMode" (ngModelChange)="onSelectedOriginModeChange($event)">
                <mat-option value="local-presence">Local presence</mat-option>
                <mat-option value="specific-number">Specific number</mat-option>
              </mat-select>
            </mat-form-field>

            @if(dialer.originMode === 'specific-number') {
            <div class="tw-space-y-2">
              <mat-form-field class="tw-w-full" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Search caller IDs</mat-label>
                <input matInput [ngModel]="dialer.originQuery" (ngModelChange)="onOriginNumberQueryChange($event)"
                  [disabled]="dialer.loadingOriginNumberOptions || dialer.savingOriginPreference" />
                <button mat-icon-button matSuffix type="button" (click)="searchOriginNumbers()"
                  [disabled]="dialer.loadingOriginNumberOptions || dialer.savingOriginPreference || !selectedIntegrationId()"
                  [attr.aria-label]="dialer.loadingOriginNumberOptions ? 'Searching caller IDs' : 'Search caller IDs'"
                  [matTooltip]="dialer.loadingOriginNumberOptions ? 'Searching caller IDs' : 'Search caller IDs'">
                  <mat-icon [class.tw-animate-spin]="dialer.loadingOriginNumberOptions">
                    {{ dialer.loadingOriginNumberOptions ? 'sync' : 'search' }}
                  </mat-icon>
                </button>
              </mat-form-field>
              <mat-form-field class="tw-w-full" appearance="outline" subscriptSizing="dynamic">
                <mat-label>Specific caller ID</mat-label>
                <mat-select [ngModel]="dialer.selectedOriginNumberId" (ngModelChange)="onSelectedOriginNumberChange($event)"
                  [disabled]="dialer.loadingOriginNumberOptions || !dialer.originNumberOptions.length">
                  @for (option of dialer.originNumberOptions; track option.phoneNumberId) {
                  <mat-option [value]="option.phoneNumberId">
                    {{ formatPhoneForDisplay(option.phoneNumber) }}
                  </mat-option>
                  }
                </mat-select>
                <mat-hint>Only eligible numbers from the selected integration are shown.</mat-hint>
              </mat-form-field>
            </div>
            }

            @if(dialer.callerIdPreview; as preview) {
              <div class="tg-sm text-muted">
                @if(preview.resolvedFromNumber) {
                <div>Caller ID preview: {{ formatPhoneForDisplay(preview.resolvedFromNumber) }}</div>
                }
                @if(preview.unavailableReason) {
                <div class="text-warning">{{ preview.unavailableReason }}</div>
                }
              </div>
            }

            <div class="tw-flex tw-justify-end">
              <button mat-flat-button class="btn-info" type="button" (click)="saveOriginPreference()"
                [disabled]="dialer.savingOriginPreference || !selectedIntegrationId()">
                Save caller ID
              </button>
            </div>
          </div>
          }
        </div>
        }

        @if(previewBlocked() && !showSingleConnectionErrorCard()) {
        <div class="uw-message uw-message-warning tw-flex tw-items-center tw-justify-between tw-gap-3">
          <span class="tg-sm">Reconnect {{ selectedIntegrationOption()?.title || 'the selected integration' }} to place calls.</span>
          <button mat-button type="button" (click)="reconnectConnection(selectedIntegrationId()!)">Reconnect</button>
        </div>
        }

        <div class="uw-card tw-space-y-2">
          <mat-form-field class="tw-w-full" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Enter a number</mat-label>
            <mat-icon matPrefix class="tw-mr-2">phone</mat-icon>
            <input matInput inputmode="tel" autocomplete="tel" [ngModel]="formatPhoneForDisplay(dialer.destination)"
              (ngModelChange)="onDialNumberChange($event)" [disabled]="!canDial()" />
            @if(dialer.destination) {
            <button mat-icon-button matSuffix type="button" [disabled]="loading.active" (click)="removeLastDialDigit()"
              aria-label="Backspace" matTooltip="Backspace">
              <mat-icon>backspace</mat-icon>
            </button>
            }
            <mat-hint>{{ dialer.destination ? 'Number will be normalized before calling' : 'Type or use the keypad'
              }}</mat-hint>
          </mat-form-field>

          <div class="tw-grid tw-grid-cols-3 tw-gap-1.5">
            @for (digit of dialButtons; track digit) {
            <button mat-flat-button type="button"
              class="tw-min-h-[2.9rem] tw-rounded-xl tw-text-[1.1rem] tw-font-semibold"
              [disabled]="!canDial() || loading.active" (click)="appendDigit(digit)">
              <span>{{digit}}</span>
            </button>
            }
          </div>

          <button mat-flat-button class="btn-success tw-w-full" type="button"
            [disabled]="!canDial() || !dialer.destination.trim() || loading.active || !callReady()" (click)="startCall()">
            <mat-icon>call</mat-icon>
            {{callButtonLabel()}}
          </button>
        </div>
        }

        @if(isWorkspaceRoute() && hasCoachTransport() && !canManualCall()) {
        <div class="uw-message uw-message-info tg-sm">
          The softphone is connected for coaching. Open Live Transfers to join an assigned call.
          @if(integrationOptions().length > 1) {
          <mat-form-field class="tw-w-full" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Integration</mat-label>
            <mat-select [ngModel]="selectedIntegrationId()" (ngModelChange)="onSelectedIntegrationChange($event)">
              @for (option of integrationOptions(); track option.integrationId) {
              <mat-option [value]="option.integrationId">{{ option.title }}</mat-option>
              }
            </mat-select>
          </mat-form-field>
          }
        </div>
        }

        @if(call.active) {
        @if(canShowThreeWaySection()) {
        @if(!hasStartedThreeWayLeg()) {
        <details class="uw-card softphone-invite">
          <summary class="softphone-disclosure">
            <mat-icon class="tw-shrink-0">person_add</mat-icon>
            <span class="tw-min-w-0 tw-flex-1">
              <span class="tg-sm tw-font-semibold tw-block">Add participant</span>
              <span class="tg-xs text-muted tw-block">{{ threeWayConnectionRecovering() ? 'Available when the call connection recovers.' : 'Invite another person to this call.' }}</span>
            </span>
            <mat-icon class="softphone-chevron tw-shrink-0">expand_more</mat-icon>
          </summary>
          <div class="tw-space-y-2 tw-pt-2">
          <mat-form-field class="tw-w-full" appearance="outline" subscriptSizing="dynamic">
            <mat-label>Third caller number</mat-label>
            <mat-icon matPrefix class="tw-mr-2">person_add</mat-icon>
            <input matInput inputmode="tel" autocomplete="tel" [ngModel]="formatPhoneForDisplay(threeWayNumber())"
              (ngModelChange)="onThreeWayNumberChange($event)"
              [disabled]="call.progress !== 'connected' || threeWayConnectionRecovering() || placingThreeWay()" />
            @if(threeWayNumber()) {
            <button mat-icon-button matSuffix type="button" [disabled]="placingThreeWay()"
              (click)="removeLastThreeWayDigit()" aria-label="Backspace third caller number" matTooltip="Backspace">
              <mat-icon>backspace</mat-icon>
            </button>
            }
          </mat-form-field>
          @if(threeWayConnectionRecovering()) {
          <div class="tg-sm text-muted">Call connection is recovering. Merge will be available when the call is stable.</div>
          }
          <button mat-flat-button class="btn-info tw-w-full" type="button" [disabled]="!canStartThreeWay()"
            (click)="startThreeWayCall()">
            <mat-icon>{{ placingThreeWay() ? 'hourglass_top' : 'call_merge' }}</mat-icon>
            Merge call
          </button>
          </div>
        </details>
        }

        @if(hasConferenceContext()) {
        <div class="uw-card softphone-participants">
          <div class="tw-flex tw-items-center tw-justify-between tw-gap-2">
            <div class="tg-title">{{ hasStartedThreeWayLeg() ? 'Conference' : 'Call' }}</div>
            <span class="uw-tag uw-tag-success">{{ conferenceOnLineText() }}</span>
          </div>

          @if(mainParticipantDisplayLeg()) {
          <div class="softphone-participant uw-progress-bar-parent">
            @if(showMainParticipantLoading()) {
            <mat-progress-bar mode="indeterminate" class="uw-progress-bar uw-progress-bar-top"></mat-progress-bar>
            }
            @let mainLeg = mainParticipantLeg();
            <div class="softphone-participant-content">
              <div
                class="surface-info tw-inline-flex tw-h-8 tw-w-8 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-font-semibold tw-uppercase">
                M
              </div>
              <div class="tw-min-w-0 tw-flex-1">
                <div class="tw-flex tw-items-center tw-gap-2">
                  <span class="uw-tag uw-tag-secondary">Main</span>
                  <span class="tg-xs text-muted">{{ mainParticipantStatusLabel() | titlecase }}</span>
                  <span class="tg-sm text-muted tw-font-mono">{{ mainParticipantTimerText() }}</span>
                </div>
                <div class="tg-sm text-muted tw-truncate">
                  {{ formatPhoneForDisplay(mainParticipantDisplayLeg()?.targetNumber || transferInfo()?.leadPhone || callLeadContext()?.leadPhone || dialerState().destination) || transferInfo()?.leadName || 'Main participant' }}
                </div>
              </div>
              <div class="tw-flex tw-items-center tw-gap-1">
                <button mat-icon-button type="button"
                  [disabled]="conferenceMutationPending() || !hasMainParticipantLeg()"
                  (click)="onMainParticipantAction(mainLeg?.muted ? 'unmute' : 'mute')"
                  [attr.aria-label]="mainLeg?.muted ? 'Unmute main participant' : 'Mute main participant'"
                  [matTooltip]="mainLeg?.muted ? 'Unmute main participant' : 'Mute main participant'">
                  <mat-icon>{{ mainLeg?.muted ? 'mic_off' : 'mic' }}</mat-icon>
                </button>
                <button mat-icon-button type="button"
                  [disabled]="conferenceMutationPending() || !hasMainParticipantLeg()"
                  (click)="onMainParticipantAction(mainLeg?.onHold ? 'unhold' : 'hold')"
                  [attr.aria-label]="mainLeg?.onHold ? 'Resume main participant' : 'Hold main participant'"
                  [matTooltip]="mainLeg?.onHold ? 'Resume main participant' : 'Hold main participant'">
                  <mat-icon>{{ mainLeg?.onHold ? 'play_arrow' : 'pause' }}</mat-icon>
                </button>
                <button mat-icon-button type="button" class="btn-danger"
                  [disabled]="conferenceMutationPending() || !hasMainParticipantLeg()"
                  (click)="endMainParticipant()" aria-label="Remove main participant" matTooltip="Remove main participant">
                  <mat-icon>call_end</mat-icon>
                </button>
              </div>
            </div>
          </div>
          }

          @if(hasStartedThreeWayLeg()) {
          <div data-testid="softphone-third-participant" class="softphone-participant uw-progress-bar-parent">
            @if(showThirdParticipantLoading()) {
            <mat-progress-bar mode="indeterminate" class="uw-progress-bar uw-progress-bar-top"></mat-progress-bar>
            }
            @let thirdLeg = thirdParticipantLeg();
            <div class="softphone-participant-content">
              <div
                class="tw-inline-flex tw-h-8 tw-w-8 tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-font-semibold tw-uppercase"
                [class.surface-success]="!thirdParticipantEnded()" [class.surface-info]="thirdParticipantEnded()">
                T
              </div>
              <div class="tw-min-w-0 tw-flex-1">
                <div class="tw-flex tw-items-center tw-gap-2">
                  <span class="uw-tag" [class.uw-tag-success]="!thirdParticipantEnded()"
                    [class.uw-tag-secondary]="thirdParticipantEnded()">Third</span>
                  <span class="tg-xs text-muted">{{ thirdParticipantStatusLabel() | titlecase }}</span>
                  <span class="tg-sm text-muted tw-font-mono">{{ thirdParticipantTimerText() }}</span>
                </div>
                <div class="tg-sm text-muted tw-truncate">
                  {{ formatPhoneForDisplay(thirdLeg?.targetNumber || threeWayNumber()) || 'Third caller' }}
                </div>
              </div>
              <div class="tw-flex tw-items-center tw-gap-1">
                <button mat-icon-button type="button"
                  [disabled]="conferenceMutationPending() || !hasThirdParticipantLeg() || thirdParticipantEnded()"
                  (click)="onThirdParticipantAction(thirdLeg?.muted ? 'unmute' : 'mute')"
                  [attr.aria-label]="thirdLeg?.muted ? 'Unmute third participant' : 'Mute third participant'"
                  [matTooltip]="thirdLeg?.muted ? 'Unmute third participant' : 'Mute third participant'">
                  <mat-icon>{{ thirdLeg?.muted ? 'mic_off' : 'mic' }}</mat-icon>
                </button>
                <button mat-icon-button type="button"
                  [disabled]="conferenceMutationPending() || !hasThirdParticipantLeg() || thirdParticipantEnded()"
                  (click)="onThirdParticipantAction(thirdLeg?.onHold ? 'unhold' : 'hold')"
                  [attr.aria-label]="thirdLeg?.onHold ? 'Resume third participant' : 'Hold third participant'"
                  [matTooltip]="thirdLeg?.onHold ? 'Resume third participant' : 'Hold third participant'">
                  <mat-icon>{{ thirdLeg?.onHold ? 'play_arrow' : 'pause' }}</mat-icon>
                </button>
                <button mat-icon-button type="button" class="btn-danger"
                  [disabled]="conferenceMutationPending() || !hasThirdParticipantLeg() || thirdParticipantEnded()"
                  (click)="endThirdParticipant()" aria-label="Remove third participant" matTooltip="Remove third participant">
                  <mat-icon>call_end</mat-icon>
                </button>
                @if(thirdParticipantEnded()) {
                <button mat-icon-button type="button" [disabled]="conferenceMutationPending()"
                  (click)="dismissEndedThirdParticipant()" aria-label="Dismiss ended caller" matTooltip="Dismiss ended caller">
                  <mat-icon>close</mat-icon>
                </button>
                }
              </div>
            </div>
          </div>
          }

        </div>
        }
        }
        }

        } @else {
        <div class="uw-message uw-message-info">
          Enable the soft phone in your transfer availability settings to receive live transfers in-app.
        </div>
        }
      </div>
    </div>
    @if(enabled() && call.active) {
    @let loading = loadingState();
    <div class="softphone-actions tw-space-y-2 tw-px-3 tw-py-2" role="group" aria-label="Your call controls">
        @if(panelState().dtmfExpanded) {
        <div class="softphone-keypad tw-space-y-2">
          <div class="tw-flex tw-items-center tw-gap-2">
            <div class="tg-title">In-call keypad</div>
            <span class="uw-tag uw-tag-secondary">DTMF</span>
          </div>
          <div class="tw-grid tw-grid-cols-3 tw-gap-1.5">
            @for (digit of dialButtons; track digit) {
            <button mat-flat-button type="button"
              class="tw-min-h-10 tw-rounded-xl tw-text-[1.1rem] tw-font-semibold" [disabled]="!call.active"
              (click)="appendDigit(digit)">
              <span>{{digit}}</span>
            </button>
            }
          </div>
        </div>
        }

        <div class="tw-grid tw-grid-cols-3 tw-gap-2">
          <button mat-stroked-button type="button" class="softphone-control"
            (click)="toggleDtmfCardExpanded()"
            [attr.aria-pressed]="panelState().dtmfExpanded"
            [class.softphone-control-active]="panelState().dtmfExpanded"
            [attr.aria-label]="panelState().dtmfExpanded ? 'Hide DTMF keypad' : 'Show DTMF keypad'"
            [matTooltip]="panelState().dtmfExpanded ? 'Hide keypad' : 'Show keypad'">
            <span class="tw-inline-flex tw-items-center tw-justify-center tw-gap-1.5 tg-sm">
              <mat-icon>dialpad</mat-icon>
              <span>Keypad</span>
            </span>
          </button>
          <button mat-stroked-button type="button" class="softphone-control"
            [class.softphone-control-active]="call.muted"
            [attr.aria-pressed]="call.muted" [disabled]="!canToggleMute()" (click)="toggleMute()"
            [attr.aria-label]="call.muted ? 'Unmute call' : 'Mute call'" [matTooltip]="call.muted ? 'Unmute' : 'Mute'">
            <span class="tw-inline-flex tw-items-center tw-justify-center tw-gap-1.5 tg-sm">
              <mat-icon>{{ call.muted ? 'mic_off' : 'mic' }}</mat-icon>
              <span>{{ call.muted ? 'Unmute' : 'Mute' }}</span>
            </span>
          </button>
          @if(hasConferenceParticipants()) {
          <button mat-stroked-button type="button" class="softphone-control"
            [class.softphone-control-active]="call.onHold"
            [attr.aria-pressed]="call.onHold" [disabled]="!canToggleHold()" (click)="toggleHold()"
            [attr.aria-label]="call.onHold ? 'Resume softphone leg' : 'Hold softphone leg'"
            [matTooltip]="call.onHold ? 'Resume softphone leg' : 'Hold softphone leg'">
            <span class="tw-inline-flex tw-items-center tw-justify-center tw-gap-1.5 tg-sm">
              <mat-icon>{{ loading.pendingAgentHoldAction ? 'hourglass_top' : (call.onHold ? 'play_arrow' : 'pause')
                }}</mat-icon>
              <span>{{ call.onHold ? 'Resume' : 'Hold' }}</span>
            </span>
          </button>
          }
        </div>

        @if(hasConferenceParticipants()) {
        <div class="tw-space-y-1">
          <div class="tw-grid tw-grid-cols-2 tw-gap-2">
          <button mat-flat-button class="btn-danger tw-w-full tw-min-w-0 tw-min-h-12 tw-px-2" type="button" [disabled]="!canEndConference()"
            (click)="endConference()" aria-label="End conference for everyone">
            <mat-icon>{{ loading.endingConference ? 'hourglass_top' : 'call_end' }}</mat-icon>
            <span class="tw-whitespace-normal tw-leading-5">End for everyone</span>
          </button>
          <button mat-stroked-button class="btn-secondary tw-w-full tw-min-w-0 tw-min-h-12 tw-px-2" type="button"
            [disabled]="conferenceMutationPending()" (click)="leaveConference()" aria-label="Leave conference">
            <mat-icon>logout</mat-icon>
            <span class="tw-whitespace-normal tw-leading-5">Leave conference</span>
          </button>
          </div>
          <div class="tg-sm text-muted tw-text-center">Other participants stay connected.</div>
        </div>
        } @else {
        <button mat-flat-button class="btn-danger tw-w-full" type="button" (click)="endCall()"
          aria-label="Hang up" matTooltip="Hang up">
          <mat-icon>call_end</mat-icon>
          Hang up
        </button>
        }
    </div>
    }
    <div class="uw-progress-bar-parent tw-flex tw-items-center tw-gap-2 tw-px-3 tw-py-2 tw-border-t">
      @if(loadingState().showProgressBar) {
      <mat-progress-bar mode="indeterminate" class="uw-progress-bar uw-progress-bar-top"></mat-progress-bar>
      }
      <div class="tw-flex tw-w-full tw-items-center tw-gap-2">
        <app-report-issue [softphone]="true" [debugProvider]="buildSoftphoneDebugSnapshot" [submissionResult]="onSoftphoneReportSubmitted"></app-report-issue>
        @if(sessionState().isOwner && enabled()) {
        <button mat-icon-button type="button" (click)="openTabControlDialog()"
          aria-label="Softphone tab control" matTooltip="Softphone tab control">
          <mat-icon>tab</mat-icon>
        </button>
        }
        @if(showFooterConnectionSummary()) {
        <div class="tw-flex tw-min-w-0 tw-flex-1 tw-flex-wrap tw-items-center tw-gap-2">
          <div class="tw-flex tw-min-w-0 tw-flex-1 tw-flex-wrap tw-items-center tw-gap-2">
            <mat-icon class="tw-shrink-0"
              [class.text-success]="footerSummaryTone() === 'success'"
              [class.text-warning]="footerSummaryTone() === 'warning'"
              [class.text-danger]="footerSummaryTone() === 'danger'"
              [class.text-muted]="footerSummaryTone() === 'secondary'">
              {{ footerSummaryIcon() }}
            </mat-icon>
            <div class="tw-flex tw-min-w-0 tw-flex-wrap tw-items-center tw-gap-1.5">
              @for (item of footerSummaryItems(); track item.label) {
              <span class="uw-tag tg-xs tw-whitespace-nowrap"
                [class.uw-tag-success]="item.tone === 'success'"
                [class.uw-tag-warning]="item.tone === 'warning'"
                [class.uw-tag-danger]="item.tone === 'danger'"
                [class.uw-tag-secondary]="item.tone === 'secondary'">
                {{ item.count }} {{ item.label }}
              </span>
              }
            </div>
          </div>
          <button mat-icon-button type="button" [class.btn-danger]="hasConnectionIssues()"
            (click)="openConnectionDetailsDialog()" aria-label="Connection details" matTooltip="Connection details">
            <mat-icon>info_outline</mat-icon>
          </button>
        </div>
        }
      </div>
    </div>
    }
  </div>
</ng-template>

<ng-template #endConferenceConfirmation>
  <div mat-dialog-title>End conference?</div>
  <mat-dialog-content>Disconnect everyone in this conference?</mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false" type="button">Cancel</button>
    <button mat-flat-button class="btn-danger" [mat-dialog-close]="true" type="button">End conference</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #leaveConferenceConfirmation>
  <div mat-dialog-title>Leave conference?</div>
  <mat-dialog-content>You’ll disconnect. Other participants will stay connected.</mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button [mat-dialog-close]="false" type="button">Cancel</button>
    <button mat-flat-button class="btn-secondary" [mat-dialog-close]="true" type="button">Leave conference</button>
  </mat-dialog-actions>
</ng-template>

<ng-template #browserSessionDialog>
  <div mat-dialog-title class="tw-flex tw-items-center tw-gap-2">
    <mat-icon class="text-muted tw-shrink-0">{{ browserSessionMode() === 'blocked' ? 'phone_in_talk' : 'devices' }}</mat-icon>
    <span>{{ browserSessionMode() === 'blocked' && !activeBrowserSession()
      ? 'Soft phone is still busy'
      : activeBrowserSession()
        ? 'Soft phone is active elsewhere'
        : 'Soft phone is in standby' }}</span>
  </div>
  <mat-dialog-content class="tw-space-y-4">
    <p class="tg-sm text-muted tw-m-0">Only one browser can run your soft phone at a time.</p>
    @if(activeBrowserSession(); as activeBrowser) {
    <div class="uw-card uw-card-outlined tw-flex tw-items-start tw-gap-3 tw-shadow-none">
      <mat-icon class="text-muted tw-shrink-0">computer</mat-icon>
      <div class="tw-min-w-0 tw-space-y-1">
        <div class="tg-sm tw-font-semibold">{{activeBrowser.browserName}} on {{activeBrowser.osName}}</div>
        <div class="tg-sm text-muted">Last seen {{browserSessionLastSeenText()}}</div>
      </div>
    </div>
    }
    @if(browserSessionMode() === 'blocked') {
    <div class="uw-message uw-message-warning uw-message-card tg-sm">
      An active softphone call must end before you can switch browsers.
    </div>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="tw-flex tw-flex-col tw-gap-2 sm:tw-flex-row">
    <button mat-stroked-button class="tw-w-full sm:tw-w-auto" type="button" (click)="stayOnOtherBrowser()">
      Stay on other browser
    </button>
    <button mat-flat-button class="btn-success tw-w-full sm:tw-w-auto" type="button" (click)="switchToThisBrowser()"
      [disabled]="switchingBrowserSession()">
      {{ switchingBrowserSession()
        ? 'Switching…'
        : browserSessionMode() === 'blocked' ? 'Retry switch' : 'Switch to this browser' }}
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #connectionDetailsDialog>
  <div mat-dialog-title>Connection details</div>
  <mat-dialog-content class="tw-space-y-2">
    <div class="tw-flex tw-flex-wrap tw-gap-2">
      @for (count of connectionSummaryCounts(); track count.label) {
      <span class="uw-tag uw-tag-secondary">{{ count.count }} {{ count.label }}</span>
      }
    </div>

    <div class="tw-space-y-2">
      @for (connection of connectionRows(); track connection.integrationId; let isFirst = $first; let isLast = $last) {
      <div class="tw-flex tw-items-start tw-gap-3 tw-border-t tw-py-3"
        [class.tw-border-t-0]="isFirst"
        [class.tw-pt-0]="isFirst"
        [class.tw-pb-0]="isLast">
        <div class="tw-min-w-0 tw-flex-1">
          <div class="tg-sm tw-font-semibold tw-truncate">{{ connection.title }}</div>
          <div class="tg-xs text-muted">{{ connection.statusLabel }}</div>
          @if(connection.issueSummary) {
          <div class="tg-xs text-muted tw-break-words">{{ connection.issueSummary }}</div>
          }
        </div>
        @if(connection.status === 'error' || connection.status === 'disconnected') {
        <button mat-button type="button" (click)="reconnectConnection(connection.integrationId)">Reconnect</button>
        }
      </div>
      }
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="tw-flex tw-justify-between tw-gap-2">
    <div class="tw-flex tw-gap-2">
      @if(showSingleConnectionErrorCard()) {
      <button mat-stroked-button type="button" (click)="reconnect()">Reconnect</button>
      } @else if(connectionSummary().partialFailure) {
      <button mat-stroked-button type="button" (click)="reconnectFailed()">Reconnect failed</button>
      } @else if(connectionSummary().allFailed) {
      <button mat-stroked-button type="button" (click)="reconnect()">Reconnect all</button>
      }
    </div>
    <button mat-button mat-dialog-close type="button">Close</button>
  </mat-dialog-actions>
</ng-template>
<ng-template #tabControlDialog>
  <div mat-dialog-title>Softphone tab control</div>
  <mat-dialog-content>
    <p>{{ sessionState().isOwner ? 'This tab controls the softphone.' : 'This tab no longer controls the softphone.' }}</p>
    @if(hasAnyCall()) {
    <p class="tg-sm text-muted">End the active call before releasing control to another tab.</p>
    }
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close type="button">Close</button>
    <button mat-stroked-button type="button" (click)="releaseSoftphoneOwnership()"
      [disabled]="hasAnyCall() || !sessionState().isOwner">Release softphone</button>
  </mat-dialog-actions>
</ng-template>
